// extracted by mini-css-extract-plugin
export default {"soup":"soup_soup__WETuG"};